module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.query.type == 'syl'),
      expression: "$route.query.type == 'syl'"
    }],
    staticClass: "questionnaire"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('swiper', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnwser == 1),
      expression: "canAnwser == 1"
    }],
    ref: "mySwiper",
    attrs: {
      "id": "swiperBox",
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "fertilityOne"
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "width": "45%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.logimg
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "topimg",
    staticStyle: {
      "display": "block",
      "height": "auto",
      "margin": "0 auto 10px"
    },
    attrs: {
      "src": _vm.onetopimg
    }
  }), _vm._v(" "), _c('h2', [_vm._v("我的生育力还好吗？")]), _vm._v(" "), _c('div', {
    staticClass: "divideLine"
  }, [_c('span', [_vm._v("评估有什么用？")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "color": "#767676",
      "line-height": "1.4rem",
      "font-size": "0.875rem"
    }
  }, [_vm._v("这是从专业医生的角度，针对备孕夫妻的生活习惯、身体条件、既往病史和治疗史，为你进行初步测评。它会帮助你充分客观地了解自己的受孕条件，科学地安排生育计划和治疗方向。")]), _vm._v(" "), _c('div', {
    staticClass: "divideLine"
  }, [_c('span', [_vm._v("评估后可以得到什么？")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("夫妻生育力自评")]), _vm._v(" "), _c('li', [_vm._v("个体化受孕分析")]), _vm._v(" "), _c('li', [_vm._v("个体化好孕策略")])]), _vm._v(" "), _c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.nextPage($event)
      }
    }
  }, [_vm._v("开始评估")])], 1)]), _vm._v(" "), _c('swiper-slide', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "fertilityTwo"
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "width": "45%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.logimg
    }
  }), _vm._v(" "), _c('h2', [_vm._v("我的生育力还好吗？")]), _vm._v(" "), (_vm.attention) ? _c('div', {
    staticClass: "exam-attention bgcolor"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.attention)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "bg",
    attrs: {
      "src": _vm.fertilityTwoBg
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "upSlide",
    on: {
      "click": function($event) {
        _vm.swiper.slideTo(_vm.swiper.activeIndex + 1, 1000, false)
      }
    }
  }, [_c('div', {
    staticClass: "mouse-icon"
  }, [_c('div', {
    staticClass: "wheel"
  })])])]), _vm._v(" "), _vm._l((_vm.currentModule.subjects), function(item, i) {
    return _c('swiper-slide', {
      key: i,
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "fertilitythree"
    }, [_c('img', {
      staticStyle: {
        "display": "block",
        "width": "45%",
        "height": "auto"
      },
      attrs: {
        "src": _vm.logimg
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "exam-div",
      attrs: {
        "id": 'attention' + i
      }
    }, [(item.type == 1 || item.type == 2) ? _c('ChooseTempelet', {
      attrs: {
        "data": item,
        "index": i
      },
      on: {
        "change": _vm.ChooseChange
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 3) ? _c('judementTempelet', {
      attrs: {
        "data": item,
        "index": i
      },
      on: {
        "change": _vm.ChooseChange
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (((item.type == 1 || item.type == 2) && item.choices.answer != '') || (item.type === 3 && item.judement.answer != '')),
        expression: "((item.type == 1 || item.type == 2) && item.choices.answer !='') || (item.type === 3 && item.judement.answer !='')"
      }],
      staticClass: "upSlide",
      on: {
        "click": function($event) {
          _vm.swiper.slideTo(_vm.swiper.activeIndex + 1, 1000, false)
        }
      }
    }, [_c('div', {
      staticClass: "mouse-icon"
    }, [_c('div', {
      staticClass: "wheel"
    })])])])
  }), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "fertilityend"
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "width": "45%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.logimg
    }
  }), _vm._v(" "), _c('h2', [_vm._v("请留下您的联系方式")]), _vm._v(" "), (_vm.attention) ? _c('div', {
    staticClass: "exam-attention bgcolor",
    staticStyle: {
      "margin": "20px 0"
    }
  }, [_c('div', {
    staticClass: "zdyform"
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "title": "姓名：",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "max": 11,
      "is-type": _vm.chinamobile,
      "title": "电话：",
      "placeholder": "请输入电话"
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "bg",
    attrs: {
      "src": _vm.fertilityTwoBg
    }
  })]) : _vm._e(), _vm._v(" "), _c('x-button', {
    staticClass: "submitbtn",
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("提 交")])], 1)])], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnwser == 2),
      expression: "canAnwser == 2"
    }]
  }, [(_vm.examType != '3') ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "30px"
    },
    attrs: {
      "type": "success",
      "is-msg": ""
    }
  }), _vm._v(" "), (_vm.queryParam.examinationId !== '1338313084932235266') ? _c('div', [_vm._v("谢谢您的宝贵意见，我们将持续改进，旨在为患者提供更加优质的医疗服务！")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.examType == '3' && _vm.$route.query.type !== 'syl') ? _c('div', {
    staticClass: "text-center strip-div white-text l-font",
    staticStyle: {
      "background": "url('http://front.wh.jinxin-fertility.com/static/images/strip.png') no-repeat",
      "background-size": "100%",
      "background-position": "center"
    }
  }, [_c('div', [_vm._v("你的综合得分")])]) : _vm._e(), _vm._v(" "), (_vm.examType == '3' && _vm.$route.query.type == 'syl') ? _c('div', {
    staticClass: "result"
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "width": "45%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.logimg
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_c('h2', [_vm._v("囡囡指导评语")]), _vm._v(" "), _c('div', {
    staticClass: "con bgcolor"
  }, [_vm._v("\n              " + _vm._s(_vm.eval) + "\n           ")])]), _vm._v(" "), _c('li', [_c('h2', [_vm._v("囡囡好孕策略")]), _vm._v(" "), _c('div', {
    staticClass: "con bgcolor"
  }, [_vm._v("\n              " + _vm._s(_vm.suggest) + "\n            ")])])])]) : _vm._e(), _vm._v(" "), (_vm.score > 0) ? _c('div', {
    staticClass: "xxl-font text-center",
    staticStyle: {
      "color": "#4ba7e8"
    }
  }, [_c('span', {
    attrs: {
      "id": "total"
    }
  }, [_vm._v(_vm._s(_vm.score))]), _vm._v("分")]) : _vm._e(), _vm._v(" "), (_vm.examType == '3' && _vm.evalLevel != '' && (_vm.evalLevel == '正常' || _vm.evalLevel == '睡眠质量很好')) ? _c('div', {
    staticClass: "xl-font text-center",
    staticStyle: {
      "color": "#4ba7e8"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.evalLevel))])]) : _vm._e(), _vm._v(" "), (_vm.examType == '3' && _vm.evalLevel != '' && (_vm.evalLevel != '正常' || _vm.evalLevel != '睡眠质量很好')) ? _c('div', {
    staticClass: "xl-font text-center",
    staticStyle: {
      "color": "red"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.evalLevel))])]) : _vm._e(), _vm._v(" "), (_vm.examType != '3') ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.remark) ? _c('p', {
    staticClass: "m-font gray-text"
  }, [_vm._v(_vm._s(_vm.remark))]) : _vm._e(), _vm._v(" "), (_vm.eval) ? _c('hr') : _vm._e(), (_vm.eval) ? _c('p', {
    staticClass: "cyan-text l-font"
  }, [_vm._v("描述")]) : _vm._e(), _vm._v(" "), (_vm.eval) ? _c('p', {
    staticClass: "m-font gray-text"
  }, [_vm._v(_vm._s(_vm.eval))]) : _vm._e(), _vm._v(" "), (_vm.suggest) ? _c('hr') : _vm._e(), (_vm.suggest) ? _c('p', {
    staticClass: "cyan-text l-font"
  }, [_vm._v("建议")]) : _vm._e(), _vm._v(" "), (_vm.suggest) ? _c('p', {
    staticClass: "m-font gray-text",
    domProps: {
      "innerHTML": _vm._s(_vm.suggest)
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "questionnaireDialog",
    attrs: {
      "hide-on-blur": true
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "questionnaireDialogBg"
  }, [_c('div', {
    staticClass: "con"
  }, [_c('h2', [_vm._v("提交成功")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.query.personType == 1),
      expression: "$route.query.personType == 1"
    }],
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.query.personType == 1),
      expression: "$route.query.personType == 1"
    }]
  }, [_vm._v("稍后将有专人与您联系"), _c('br'), _vm._v("一对一为您解读测评结果")]), _vm._v(" "), _c('icon', {
    staticStyle: {
      "color": "#fff",
      "font-size": "90px",
      "font-weight": "bold",
      "margin-top": "20px"
    },
    attrs: {
      "type": "success-circle"
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "bg",
    attrs: {
      "src": _vm.fertilityTwoBg
    }
  })]), _vm._v(" "), _c('icon', {
    staticStyle: {
      "font-size": "40px",
      "color": "#fff",
      "margin-top": "15px",
      "position": "relative",
      "z-index": "1"
    },
    attrs: {
      "type": "cancel"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": "加载中..."
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-031db6e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/exam/questionnaire.vue
// module id = 0aPP
// module chunks = 7